<template>
    <table class="table pricelist table-striped">
        <thead>
            <tr>
                <th>Saison</th>
                <th>Zeiten</th>
                <th>z.B. Preis für eine Woche inklusive Endreinigung und Bettwäsche für einen Gast</th>
            </tr>
        </thead>

        <tbody>
            <tr v-for="season in seasonsWithPrice"
                :key="season.name">
                <td>{{ season.name }}</td>

                <td>
                    <div v-for="p in season.seasonPeriods"
                        :key="p">
                        {{ p }}
                    </div>
                </td>

                <td>
                    ab {{ season.price.toFixed(2).replace('.', ',') }} €
                    <br>
                    <span class="small">
            Inklusive Endreinigung, Bettwäsche
          </span>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
    	voVueComponent: 'seasonprices',
    	props: {
    		pricelist: String
    	},

    	computed: {

    		parsedPricelist: function() {
    			return JSON.parse(this.pricelist || '[]');
    		},

    		/* ---------- Services holen ---------- */

    		rentService: function() {
    			return this.findServiceByType('RENT');
    		},

    		taxService: function() {
    			return this.findServiceByType('VTAX');
    		},

    		cleaningService: function() {
    			return this.findServiceByType('FINALCLEANING');
    		},

    		bookingService: function() {
    			var list = this.parsedPricelist;

    			for (var i = 0; i < list.length; i++) {
    				var s = list[i];
    				if (s.service &&
    					(s.service.type === 'BOOKING_FEE' || s.service._id === 63200)) {
    					return s;
    				}
    			}
    			return null;
    		},

    		bettwaescheService: function() {
    			return this.findServiceById(33333);
    		},

    		/* ---------- Saisons gruppieren ---------- */

    		seasons: function() {
    			var service = this.rentService;
    			if (!service || !service.lines) return [];

    			var grouped = {};

    			service.lines.forEach(function(l) {
    				if (!grouped[l.season]) grouped[l.season] = [];
    				grouped[l.season].push(l);
    			});

    			var result = [];
    			for (var name in grouped) {
    				result.push({
    					name: name,
    					seasonPeriods: grouped[name].map(this.formatPeriod)
    				});
    			}

    			return result;
    		},

    		/* ---------- Preise berechnen ---------- */

    		seasonsWithPrice: function() {
    			var self = this;

    			return this.seasons.map(function(season) {

    				var rental = self.getRental(season.name);
    				var tax = self.getTax(season.name);
    				var cleaning = self.getFlat(self.cleaningService);
    				var booking = self.getFlat(self.bookingService);
    				var bett = self.getFlat(self.bettwaescheService);

    				//console.log('tax:::', tax)

    				return {
    					name: season.name,
    					seasonPeriods: season.seasonPeriods,
    					price: (rental + tax + cleaning + booking + bett) / 100
    				};
    			});
    		}
    	},

    	/* ====================================================== */

    	methods: {

    		/* ---------- Helpers ---------- */

    		findServiceByType: function(type) {
    			var list = this.parsedPricelist;

    			for (var i = 0; i < list.length; i++) {
    				if (list[i].service && list[i].service.type === type) {
    					return list[i];
    				}
    			}
    			return null;
    		},

    		findServiceById: function(id) {
    			var list = this.parsedPricelist;

    			for (var i = 0; i < list.length; i++) {
    				if (list[i].service && list[i].service._id === id) {
    					return list[i];
    				}
    			}
    			return null;
    		},

    		formatPeriod: function(l) {
    			var from = new Date(l.fromdate).toLocaleDateString('de-DE');
    			var till = new Date(l.tilldate).toLocaleDateString('de-DE');
    			return from + ' - ' + till;
    		},

    		/* ---------- Preisfunktionen ---------- */

    		getRental: function(seasonName) {
    			var s = this.rentService;
    			if (!s || !s.lines) return 0;

    			for (var i = 0; i < s.lines.length; i++) {
    				if (s.lines[i].season === seasonName) {
    					return s.lines[i].value * 7;
    				}
    			}
    			return 0;
    		},

    		getTax: function(seasonName) {
    			var s = this.taxService;
    			//console.log('this.taxService::', this.taxService);
    			if (!s || !s.lines) return 0;

    			for (var i = 0; i < s.lines.length; i++) {
    				var l = s.lines[i];

    				//console.log(l.season, '-', seasonName);

    				if (l.season === seasonName) {
    					return l.calculation === 'NIGHT' ? l.value * 7 : l.value;
    				}
    			}
    			return 0;
    		},

    		getFlat: function(service) {
    			if (!service || !service.price) return 0;

    			if (service.service &&
    				service.service.calculation === 'NIGHT') {
    				return service.price * 7;
    			}

    			return service.price;
    		}
    	}
    };
</script>